module.exports = __webpack_public_path__ + "static/media/ellipse-blue.f1bab352.png";